define('apps/admin/views/components/clever-id-mapping-dropdown',[
        'app',
        '@discoveryedu/platform-components',
        'common/components/vue-wrapper/helpers/mount-vue-component'
    ], function(app, PlatformComponents, mountVueComponent) {
        'use strict';

        return {
            "vueEl": {},

            "selectedSiteData": {},

            "cleverId": null,

            "renderSiteList": function(data) {
                this.cleverId = data.cleverId;
                this.selectedSiteData = {
                    "accountId": data.accountId,
                    "cleverId": data.cleverId,
                };

                this.vueEl = mountVueComponent(
                    PlatformComponents.CleverIDMappingDropdown,
                    '#school-list-dropdown-' + data.cleverId + '> .school-dropdown-render',
                    {
                        "sites": data.sites,
                        "mappedSchoolGuid": data.mappedSchoolGuid,
                        "clearOptionLabel": "None - Unmap school",
                        "siteStatusLabel": "(Archived)",
                        "noResultsLabel": "No school by the name",
                        "onSiteSelected": _.bind(this.postSelectedSite, this)
                    }
                );
            },

            "postSelectedSite": function(site) {
                this.selectedSiteData = Object.assign(this.selectedSiteData, site);

                // Update the dataset for the next time the dropdown gets rendered
                // (the same Vue component is NOT reused, so this data gets
                // read again from DOM attributes)
                $('.school-select[data-clever-id=' + this.cleverId + ']')
                    .attr('data-mapped-school-guid', site.site_guid);
            },

        };
});

